(() => {
  const ready = new WeakSet();

  const updateFinish = (input) => {
    const optionName = (input?.dataset?.optionName || '').toLowerCase();
    if (!optionName.includes('metal color') && !optionName.includes('metal colour')) return;
    const product = input.closest('product-info') || document;
    const finish = product.querySelector('[data-gemlay-snapshot-finish]');
    if (finish && input.value) finish.textContent = input.value;
  };

  const copyOfferCode = async (button) => {
    const code = button?.dataset?.gemlayOfferCode;
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
    } catch (_) {
      const input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    const label = button.querySelector('[data-gemlay-offer-copy-label]');
    if (!label) return;
    const original = label.textContent;
    label.textContent = 'Copied';
    window.setTimeout(() => { label.textContent = original; }, 1600);
  };

  const initSlider = (slider) => {
    if (ready.has(slider)) return;
    ready.add(slider);

    const slides = [...slider.querySelectorAll('[data-gemlay-offer-slide]')];
    const dots = [...slider.querySelectorAll('[data-gemlay-offer-dot]')];
    if (slides.length < 2) return;

    let index = 0;
    let timer = null;
    let touchStartX = 0;
    const autoplayMs = Math.max(3000, Number(slider.dataset.autoplayMs) || 5000);
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    const show = (next, userInitiated = false) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
      if (userInitiated) restart();
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (reducedMotion || document.hidden || timer) return;
      timer = window.setInterval(() => show(index + 1), autoplayMs);
    };

    const restart = () => {
      stop();
      start();
    };

    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.index) || 0, true)));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    slider.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      const endX = event.changedTouches[0]?.clientX || 0;
      const delta = endX - touchStartX;
      if (Math.abs(delta) < 35) return;
      show(index + (delta < 0 ? 1 : -1), true);
    }, { passive: true });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

    show(0);
    start();
  };

  const mount = (scope = document) => scope.querySelectorAll('[data-gemlay-offer-slider]').forEach(initSlider);

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('input[data-option-name]');
    if (input) updateFinish(input);
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-gemlay-offer-copy]');
    if (button) copyOfferCode(button);
  });
  document.addEventListener('shopify:section:load', (event) => mount(event.target));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
})();
